import { supabaseClient } from "@/lib/supabase";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

export async function managerGetArthrosamidDiaries() {
	const { data, error } = await supabaseClient.functions.invoke(
		"manager-get-arthrosamid-diaries",
		{},
	);
	if (error) {
		throw error;
	}
	return data;
}

export const managerGetArthrosamidDiariesQueryOptions = () =>
	queryOptions({
		queryKey: ["arthrosamid-diaries"],
		queryFn: managerGetArthrosamidDiaries,
	});

export const useManagerGetArthrosamidDiaries = () => {
	return useSuspenseQuery(managerGetArthrosamidDiariesQueryOptions());
};
